<template>
  <v-container fluid>
    <div v-if="user.can('update_customersetting') && model">
      <div v-if="this.model.id !== this.customerContextId ">
        <v-alert show color="warning" dark border="top">
        <span v-if="this.model.name"
          v-html="$t('customer_general_settings_ui.editing_different_customer_message', {customer1: this.model.name, customer2: this.customerContext.name })"/>
          <v-btn text @click="switchContext(model)">
            {{ $t('switch_customers') }}
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </v-alert>
      </div>
      <h2 v-if="this.model">{{ $tc('customer') }} <span class="subheader text-muted">{{ model.name }}</span></h2>
      <div>
        <v-tabs show-arrows v-model="tabIndex">
          <v-tab>{{ $t('customer_ui.general_settings') }}</v-tab>
          <v-tab-item class="vf-border-top pt-1" :transition="false">
            <customer-general-settings :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $tc('feature', 2) }}</v-tab>
          <v-tab-item class="vf-border-top pt-1" :transition="false">
            <customer-features :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $t('customer_ui.root_cause_terms') }}</v-tab>
          <v-tab-item class="vf-border-top pt-5" :transition="false">
            <root-cause-terms :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $tc('vehicle_issue_terms', 2) }}</v-tab>
          <v-tab-item class="vf-border-top pt-5" :transition="false">
            <vehicle-issue-terms :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $t('customer_ui.services') }}</v-tab>
          <v-tab-item class="vf-border-top pt-5" :transition="false">
            <customer-service-providers :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $tc('api_key', 2) }}</v-tab>
          <v-tab-item class="vf-border-top pt-5" :transition="false">
            <customer-api-keys :customer="model"/>
          </v-tab-item>
          <v-tab>{{ $t('customer_ui.implementation') }}</v-tab>
          <v-tab-item class="vf-border-top" :transition="false">
            <customer-onboarding :customer="model"/>
          </v-tab-item>
        </v-tabs>
      </div>
    </div>
  </v-container>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'
import CustomerGeneralSettings from '@/components/customer/CustomerGeneralSettings'
import CustomerFeatures from '@/components/customer/CustomerFeatures'
import RootCauseTerms from '@/components/customer/RootCauseTerms'
import VehicleIssueTerms from '@/components/customer/VehicleIssueTerms'
import CustomerApiKeys from '@/components/customer/CustomerApiKeys'
import CustomerServiceProviders from '@/components/customer/CustomerServiceProviders'
import CustomerOnboarding from '@/components/customer/CustomerOnboarding'

import { isEmpty, indexOf } from 'lodash'

export default {
  name: 'CustomerUpdate',
  components: {
    CustomerApiKeys,
    CustomerGeneralSettings,
    CustomerFeatures,
    RootCauseTerms,
    VehicleIssueTerms,
    CustomerServiceProviders,
    CustomerOnboarding
  },
  mixins: [CurrentUserMixin, ApiUtilitiesMixin, BrowserUtilitiesMixin],
  data () {
    return {
      model: null,
      tabIndex: 0,
      customerOnboarding: null,
      tabs: [
        '#general-settings',
        '#features',
        '#assessment-terms',
        '#vehicle-issue-terms',
        '#integrated-services',
        '#api-keys',
        '#implementation-checklist'
      ]
    }
  },
  methods: {
    isEmpty: isEmpty,
    fetchModel () {
      this.$orm('Customer')
        .find(this.$route.params.id, { params: { expand: 'customer_settings,onboarding' } })
        .then((model) => {
          this.model = model
        })
        .catch(error => {
          if (error) {
            this.renderErrorModal(error)
            throw (error)
          }
        })
    },
    /**
     * @param CustomerRecord
     */
    switchContext (customer) {
      this.$store.dispatch('userModule/changeCustomerContext', customer.id)
      this.$emit('change-context', customer)
      return false
    }
  },
  mounted () {
    if (this.$route.hash) {
      this.tabIndex = indexOf(this.tabs, this.$route.hash)
    }
    this.fetchModel()
  },
  computed: {
    /** Show a checkbox at the top of the implementation checklist tab, if we have reached 100% in both sets of criteria */
    checklistCompleted () {
      return this.model.onboarding &&
        this.model.onboarding.basicPercentComplete === 100 &&
        this.model.onboarding.enterprisePercentComplete === 100
    }
  },
  watch: {
    model: function (newModel, oldModel) {
      this.updateBrowserTitle(this.$tc('customer') + ': ' + newModel.name)
    },
    tabIndex: function (newValue, oldValue) {
      return this.$router.replace({ path: this.tabs[newValue] }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    },
    '$route.hash': function (newValue, oldValue) {
      this.tabIndex = indexOf(this.tabs, newValue)
    }
  }
}
</script>

<style scoped>
</style>
